// export const lightTheme = {
//     '--color-primary': '#219ebc',
//     '--color-secondary': '#8ecae6',
//     '--text-color': '#030f36',
//     '--highlight': '#030f36',
//     '--menu-color': '#023047',
//     '--secondary-color': 'red',
//     '--white-color': 'white',
//   };

export const lightTheme = {
  '--color-primary': '#1a73e8',     // Royal Blue (for headings / buttons / highlights)
  '--color-secondary': '#e3f2fd',  // Very light blue (background sections, subtle accents)
  '--text-color': '#212529',       // Neutral dark gray for readability (instead of harsh black)
  '--highlight': '#0d1b2a',        // Deep navy for strong emphasis (like your name)
  '--menu-color': '#495057',       // Medium gray for navbar text (balanced contrast)
  '--secondary-color': '#858489',  // Teal accent (good for role line / secondary buttons)
  '--tirtiary-color': '#ff6f61',   // Coral accent (for links / icons)
  '--white-color': '#ffffff',      // Keep pure white for clean sections
};

  
  export const darkTheme = {
    '--color-primary': '#0b3d91',
    '--color-secondary': '#1d3557',
    '--text-color': '#ffffff',
    '--highlight': '#57cbff',
    '--menu-color': '#13141d',
    '--secondary-color': '#ff6f61',
    '--tirtiary-color': '#ff6f61', 
    '--white-color': '#f4f4f4',
  };
  
